<template>
  <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
    <div class="row">
      <div class="col-md-12 mb-4">
        <div class="row">
          <div class="col-md-12" align="right" v-if="!isAdmin">
            <div
              v-if="!currentLiveStream && !isLoading || currentLiveStream !== null && currentLiveStream.status === 'ended'"
            >
              <router-link to="/create_live_stream">
                <base-button type="primary">Create Live Stream</base-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4" v-if="isAdmin">
        <current-live-stream-list />
      </div>
      <div
        :class="{ 'col-md-8': isAdmin, 'col-md-12': !isAdmin, 'mt-4': currentLiveStream && currentLiveStream.status === 'live' && !isAdmin}"
      >
        <live-stream-info-table />
      </div>
    </div>
  </div>
</template>

<script>
import CurrentLiveStreamList from '@/views/LiveStream/CurrentLiveStreamList'
import LiveStreamInfoTable from '@/views/LiveStream/LiveStreamInfoTable'

import { mapGetters, mapState } from 'vuex'

import { UPDATE_LIVE_STREAM_STATUS } from '@/store/actions.type'

export default {
  components: { CurrentLiveStreamList, LiveStreamInfoTable },
  methods: {
    onPublishClicked() {
      this.$store.dispatch(UPDATE_LIVE_STREAM_STATUS, {
        id: this.currentLiveStream.id,
        status: 'live'
      })
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   window.location.reload()
  //   return next()
  // },
  computed: {
    ...mapState({
      isLoading: state => state.liveStream.isLoading
    }),
    ...mapGetters({
      isAdmin: 'isAdmin',
      currentLiveStream: 'currentLiveStream'
    })
  }
}
</script>
<style scoped>
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.info {
  color: #962100;
  font-size: 1.2em;
  font-weight: 600;
}
</style>
